import React from 'react'

import Img from 'src/components/shared/Img'
import Rating from 'src/components/shared/Rating'
import Typography from 'src/components/shared/Typography'

import ButtonLink from 'src/components/shared/ButtonLink'

const alignClass = {
  center: 'items-center',
  left: 'items-start',
  right: 'text-end',
}

const TrustPilot = ({
  rating = 0,
  totalReviews = 0,
  outOf = 5,
  color,
  link,
  onReviewClick = () => {},
  footerTextClassName = '',
  calification = 'Excellent',
  reviews = 'reviews',
  prefix,
  showOnlyStars = false,
  starSize = 24,
  align = 'center',
  priority = false,
  loading,
}) => (
  <div className={`mt-4 flex flex-col lg:mt-4 ${alignClass[align]}`}>
    <div className="mb-2 flex items-center" data-testid="trustpilot-container">
      <Img
        src="/next-assets/trust-strip/trustpilot.svg"
        alt="trustpilot"
        layout="intrinsic"
        priority={priority}
        loading={loading}
        width={88}
        height={24}
        className="shrink-0"
      />
      <div className="ml-2" data-testid="trustpilot-stars">
        <Rating
          rating={rating}
          totalStars={outOf}
          totalReviews={totalReviews}
          filledStarColor={color}
          starSize={starSize}
        />
      </div>
      {!showOnlyStars && (
        <Typography
          className={`leading-[14px] ${footerTextClassName}`}
          variant="bodySmall"
          component="span"
          data-testid="trustpilot-rating"
        >
          {rating}/{outOf}
        </Typography>
      )}
    </div>
    {!showOnlyStars && (
      <Typography
        className={footerTextClassName}
        variant="bodySmall"
        component="p"
        data-testid="trustpilot-rating-text"
      >
        <strong>{calification} • </strong>
        <ButtonLink
          className="tracking-[normal] hover:underline"
          href={link}
          onClick={onReviewClick}
          target="blank"
          data-testid="trustpilot-link"
        >
          {prefix
            ? `${prefix} ${totalReviews} ${reviews}`
            : `${totalReviews}+ ${reviews}`}
        </ButtonLink>
      </Typography>
    )}
  </div>
)

export default TrustPilot
